<template>
  <div class="noAlMargen">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <h4 v-if="activarTitulos" style="text-align:center">TU PATIENT JOURNEY</h4>

      <b-row style="width: 100%;" v-if="hc" class="text-center">
          <ul class="steps">
            <li v-for="dto in this.datos" v-bind:key="dto.idEtapa" :class="['step', 'step-'+dto.color.replace('#','')]">
              <div class="step-content" style="margin-left: -12px; !important;">
                <span class="step-circle" style="width: 21px;height: 21px;"
                      v-b-tooltip.hover.right.v-success :title="dto.estatus"
                >{{dto.origenLlenado}}</span>
                <span class="step-text">{{dto.fechaModificacion}}</span>
                <span class="step-text">{{dto.hora}}</span>
              </div>
            </li>
          </ul>
      </b-row>

      <b-row v-else style="width: 100%;">
          <ul class="steps">
            <li v-for="datoEtapa in this.datos" v-bind:key="datoEtapa.idEtapa" :class="['step', 'step-'+datoEtapa.color.replace('#','')]">
              <div class="step-content" @click="mostrar = !mostrar">
                <span class="step-circle">{{datoEtapa.idEtapa}}</span>
                <span class="step-text">{{datoEtapa.etapa.substring(2, datoEtapa.etapa.left)}}</span>
              </div>
            </li>
          </ul>
      </b-row>

    <b-modal title="Patient journey" size="lg" hide-footer v-model="mostrar">

            <PatientJourney
                height="40px"
                :desactivarTitulos="true"
                :idPaciente="idPaciente"
                :mostrar="true"
            ></PatientJourney>
    </b-modal>

  </div>
</template>

<script>
  import PatientJourney from "@/components/PatientJourney";
  export default {
    name: "PatientJourneyV2",
    components: {PatientJourney},
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      max: 100,
      datos: []
    }),
    props: {
      idPaciente: {
        default: (value) => parseInt(value)
      },
      desactivarTitulos: Boolean,
      height: String,
      mostrar: Boolean,
      hc: Boolean,
    },
    computed: {
      activarTitulos() {
        return this.desactivarTitulos !== undefined  && this.desactivarTitulos !== null && !this.desactivarTitulos && this.hc !== true
      },
      obtenerAltura() {
        return this.height !== undefined && this.height !== null ? this.height : "45px";
      }
    },
    mounted() {
      if (this.hc=== true){
        this.obteneHistoricoHC();
      }else {
        this.obtenerPatientJourneyPaciente();
      }

    },
    created() {
      this.debug = this.$localStorageService.getDebug();
    },
    methods: {
      obtenerPatientJourneyPaciente() {
        this.datos = [];
        const params = {
          idPaciente: this.idPaciente
        }
        this.$http.post(this.$api + "paciente/obtenerPatientJourney", params)
          .then((response) => {
            if (response.data.data) {
              this.datos = response.data.data;
            }
          })
          .catch(function (error) {
            console.error(error);
          });
      },
      obteneHistoricoHC() {
        this.datos = [];
        this.$http.get(this.$api + "paciente/historicoHistorial?idPaciente=" + this.idPaciente)
          .then((response) => {
            if (response.data.data) {
              this.datos = response.data.data;
            }
          })
          .catch(function (error) {
            console.error(error);
          });
      }
    }
  };
</script>

<style>
:root {
  --step-content-min-width: 80px;
  --step-content-max-width: 90px;
  --step-content-width: 90px;

  --step-content-min-width-m: 50px;
  --step-content-max-width-m: 70px;
  --step-content-width-m: 70px;

  --step-gutter: 5px;
  --step-content-padding-top: 5px;
  --step-circle-size: 30px;
  --step-circle-border-width: 2px;

  --step-default-circle-color: gray;
  --step-default-circle-bg-color: white;
  --step-default-circle-border-color: gray;
  --step-default-text-color: gray;

  --step-green-circle-color: white;
  --step-green-circle-bg-color: green;
  --step-green-circle-border-color: green;
  --step-green-text-color: green;

  --step-yellow-circle-color: black;
  --step-yellow-circle-bg-color: #FFB529;
  --step-yellow-circle-border-color: #FFB529;
  --step-yellow-text-color: #FFB529;

  --step-red-circle-color: white;
  --step-red-circle-bg-color: red;
  --step-red-circle-border-color: red;
  --step-red-text-color: red;

  --step-gray-circle-color: gray;
  --step-gray-circle-bg-color: white;
  --step-gray-circle-border-color: gray;
  --step-gray-text-color: gray;
}
</style>

<style scoped>
  .encabezado-state {
    width: 100%;
    border-radius: 10px;
    padding: 5px;
    align-content: center;
    vertical-align: middle;
  }
  .encabezado-state > .col-2 {
    padding-right: 1px;
    padding-left: 1px;
  }
  .stage {
    font-weight: bold;
    background-color: #e4e9ed;
    align-items: center;
    justify-content: center;
    color: #505050;
    font-size: 8px;
    margin-bottom: 3px;

    padding: 5px;

    border-style: solid;
    border-width: 2px;

    border-radius: 100%;
    height: 10px;
    width: 10px;
    display: inline-flex;
  }
  .stage-box {
    padding: 5px;
    background-color: #e9eaf482;
    border-radius: 30%;
    margin: 5px;
    font-size: 10px;
  }

  .tituloPatient {
    font-size: 12px;
    font-weight: bolder;
  }



  .steps {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    overflow-x: auto;
    width: 100%;
    font-size: 10px;
  }
  .steps .step:first-child {
    margin-left: auto;
  }
  .steps .step:last-child {
    margin-right: auto;
  }
  .step:first-of-type .step-circle::before {
    display: none;
  }
  .step:last-of-type .step-content {
    padding-right: 0;
  }
  .step-content {
    box-sizing: content-box;
    display: flex;
    align-items: center;
    flex-direction: column;
    width:  var(--step-content-width);
    min-width:  var(--step-content-min-width);
    max-width:  var(--step-content-max-width);
    padding-top:  var(--step-content-padding-top);
    padding-right:  var(--step-gutter);
  }

  .step-circle {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width:  var(--step-circle-size);
    height:  var(--step-circle-size);
    color:  var(--step-default-circle-color);
    border:  var(--step-circle-border-width) solid var(--step-default-circle-border-color);
    border-radius: 100%;
    background-color:  var(--step-default-circle-bg-color);
  }
  .step-circle::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left:  var(--step-circle-border-width);
    width: calc(var(--step-content-width) + var(--step-gutter) - var(--step-circle-size));
    height:  var(--step-circle-border-width);
    transform: translate(-100%, -50%);
    color:  var(--step-default-circle-border-color);
    background-color: currentColor;
  }
  .step-text {
    color:  var(--step-default-text-color);
    word-break: break-all;
    margin-top: 0.25em;
  }

  @media (max-width: 1400px) {
    .step-content {
      box-sizing: content-box;
      display: flex;
      align-items: center;
      flex-direction: column;
      width:  var(--step-content-width-m);
      min-width:  var(--step-content-min-width-m);
      max-width:  var(--step-content-max-width-m);
      padding-top:  var(--step-content-padding-top);
      padding-right:  var(--step-gutter);
    }

    .step-circle::before {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left:  var(--step-circle-border-width);
      width: calc(var(--step-content-width-m) + var(--step-gutter) - var(--step-circle-size));
      height:  var(--step-circle-border-width);
      transform: translate(-100%, -50%);
      color:  var(--step-default-circle-border-color);
      background-color: currentColor;
    }
  }


  .step-green .step-circle {
    color:  var(--step-green-circle-color);
    background-color:  var(--step-green-circle-bg-color);
    border-color:  var(--step-green-circle-border-color);
  }
  .step-green .step-circle::before {
    color:  var(--step-green-circle-border-color);
  }
  .step-green .step-text {
    color:  var(--step-green-text-color);
  }



  .step-yellow .step-circle, .step-FFB529 .step-circle {
    color:  var(--step-yellow-circle-color);
    background-color:  var(--step-yellow-circle-bg-color);
    border-color:  var(--step-yellow-circle-border-color);
  }
  .step-yellow .step-circle::before, .step-FFB529 .step-circle::before {
    color:  var(--step-yellow-circle-border-color);
  }
  .step-yellow .step-text, .step-FFB529 .step-text {
    color:  var(--step-yellow-text-color);
  }


  .step-red .step-circle {
    color:  var(--step-red-circle-color);
    background-color:  var(--step-red-circle-bg-color);
    border-color:  var(--step-red-circle-border-color);
  }
  .step-red .step-circle::before {
    color:  var(--step-red-circle-border-color);
  }
  .step-red .step-text {
    color:  var(--step-red-text-color);
  }


  .step-gray .step-circle {
    color:  var(--step-gray-circle-color);
    background-color:  var(--step-gray-circle-bg-color);
    border-color:  var(--step-gray-circle-border-color);
  }
  .step-gray .step-circle::before {
    color:  var(--step-gray-circle-border-color);
  }
  .step-gray .step-text {
    color:  var(--step-gray-text-color);
  }

</style>